export const VIDEOS = {
  upgradeOffer: "/mp4/Fintech_animation_for_loan_banner_202605191221.mp4",
};
